import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { NotificationQueueItem, Notification } from '@wix/da-shared-react/pkg/Notifications';
import { NotificationDuration } from '@wix/da-shared-react/pkg/Notifications/Notification';
import SystemNotification from '@wix/da-shared-react/pkg/SystemNotification';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import { useEditDeviationClick } from '../../hooks/useEditDeviationClick';

import s from './DeviationMergeNotification.scss';

export interface Props extends Omit<NotificationQueueItem, 'type'> {
  deviation?: PapiDeviation;
  deviationIds?: number[];
}

const DeviationMergeNotification: FC<Props> = ({ id, queueName, deviation, deviationIds = [] }) => {
  const { t } = useTranslation();
  const { onEditClick } = useEditDeviationClick(deviation);
  const numMergedDeviations = deviationIds.length;
  const numTotalDeviations = numMergedDeviations + 1; // including the main deviation

  const customIcon = deviation ? (
    <Dumbo deviation={deviation} width={48} height={48} />
  ) : (
    <div className={s['count-icon']}>+{numMergedDeviations}</div>
  );

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{
        className: s['notification-card'],
        textClassName: s['notification-card-text'],
        iconClassName: s['notification-card-icon'],
        customIcon,
        multiLine: true,
        limitTextWidth: false,
        duration: NotificationDuration.S,
        actions: [
          {
            label: t('studio.notifications.deviationSubmit.actions.editDraft'),
            onClick: onEditClick,
            closeOnClick: true,
          },
        ],
      }}
    >
      {t('studio.notifications.deviationMerge.text', {
        count: numTotalDeviations,
      })}
    </Notification>
  );
};
DeviationMergeNotification.displayName = 'DeviationMergeNotification';

export default DeviationMergeNotification;
